import {throttle} from 'throttle-debounce';
import m from '../helpers/metrics';
var h = require('../helpers/helpers');

var tBar = document.getElementsByClassName('js-topbar')[0]; // Topbar element
var sControl = document.getElementsByClassName('js-topbar_scroll')[0]; // Scroll control element

var tBar_height;

// Interactions
// Manages topbar fixing and read progress
// ------------------------------------------------------
function topbarInteractions() {
  var pBar = document.getElementsByClassName('js-topbar_progress')[0];
  var fixed_class = 's-fixed';
  var hideScroll_class = 's-hideScroll';
  var shortDelay_class = 's-scrollBtnShortDelay';

  // Obj caching
  var body = document.body;
  var html = document.documentElement;

  // Updating dims
  var doc_h;
  var tBar_pos;
  var sControl_offset;

  // Split dimension updates between element and scroll polls
  // ------------------------------------------------------
  function updateElementDims() {
    tBar_pos = h.getCoords(tBar).top;

    sControl_offset = tBar_pos - (sControl.clientHeight * 4);
    doc_h = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    // Store topbar height
    tBar_height = tBar.offsetHeight - 3; // Account for browser rounding bias
    var scroll_items = document.getElementsByClassName('js-scrollAnchors');

    for (var i=0; i < scroll_items.length; ++i) {
      scroll_items[i].setAttribute('data-scrollanchors-offset', -tBar_height);
    }
  }

  // Update progress bar
  // ------------------------------------------------------
  function updateProgress() {
    var scrollPercent = 100 - 100 * m('scroll_y') / (doc_h - m('win_height'));

    pBar.style.transform = 'translate3D(-'+ scrollPercent +'%,0,0)';
  }

  // Get the position of the bar
  // ------------------------------------------------------
  function hideScrollControl() {
    if (m('scroll_y') >= sControl_offset) {
      tBar.classList.add(hideScroll_class);
      tBar.classList.add(shortDelay_class);
    }
    else if (m('scroll_y') < sControl_offset) {
      tBar.classList.remove(hideScroll_class);
    }
  }

  // Get the position of the bar
  // ------------------------------------------------------
  function fixTopbar() {
    if (m('scroll_y') >= tBar_pos) {
      tBar.classList.add(fixed_class);
    }
    else if (m('scroll_y') < tBar_pos) {
      tBar.classList.remove(fixed_class);
    }
  }

  function onScroll() {
    hideScrollControl();
    fixTopbar();
    updateProgress();
  }
  var onScroll__throttled = throttle(10, onScroll);

  function onResize() {
    updateElementDims();

    hideScrollControl();
    fixTopbar();
    updateProgress();
  }
  var onResize__throttled = throttle(50, onResize);

  function initLoad() {
    onScroll();
    onResize();
  }

  // Bind events
  // ------------------------------------------------------
  function bindEvents() {

    // Retrieve element dimensions when page is fully loaded
    // Prevent race condition where measurements are calculated before page is fully flowed
    window.addEventListener('load', initLoad);

    // Update get element dims on resize and they only change when layout is adjusted
    window.addEventListener('resize', onResize__throttled);

    // Run checking logic on scroll
    // Lower freq to minimize jank when scroll at high speeds
    window.addEventListener('scroll', onScroll__throttled);
  }

  // Kickoff
  // ------------------------------------------------------
  initLoad();

  // Bind events
  bindEvents();
}

// Check for element existence prior to execution
if (tBar) {
  topbarInteractions();
}

export {
  tBar as el,
};

